import { Pencil } from 'react-bootstrap-icons';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { IWarehouse } from "../../api/types";
import { WarehouseForm } from './WarehouseForm';
import { useState } from 'react';

export const EditButton = (props: { warehouse: IWarehouse, update: (updates: Partial<IWarehouse>) => void }) => {
  const [open, setOpen] = useState(false)

  return <>
    <OverlayTrigger overlay={<Tooltip>Edit Warehouse</Tooltip>}>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(true)}>
        <Pencil />
      </Button>
    </OverlayTrigger>
    <Modal show={open} onHide={() => setOpen(false)}>
      <WarehouseForm onClose={() => setOpen(false)} onSave={props.update} warehouse={props.warehouse}/>
    </Modal>
  </>
}